// src/components/AuthShell.js
// Two-column layout for every auth screen: a display line + note on the left,
// the form on one sheet on the right. Stacks on phones.
import Mascot from './Mascot';
import '../styles/pages/Auth.css';

const AuthShell = ({ display, say, points, children }) => (
  <div className="auth-page">
    <div className="auth-shell">
      <aside className="auth-aside">
        <p className="auth-aside__display">{display}</p>
        {say && (
          <div className="auth-say">
            <Mascot size={40} />
            <div className="auth-say__bubble">
              <b>Michii says</b>
              <span>{say}</span>
            </div>
          </div>
        )}
        {points && (
          <ul className="auth-points">
            {points.map((p) => <li key={p}>{p}</li>)}
          </ul>
        )}
      </aside>
      <div className="auth-container m-sheet">{children}</div>
    </div>
  </div>
);

export default AuthShell;
